import SingletonDuckEntity from './SingletonDuckEntity';
import { actionize, apiAction, apiFetch } from '../utils';

const duck = new SingletonDuckEntity('veracrossConfig');

let types = {
  TEST_CREDENTIALS_BEGIN: null,
  TEST_CREDENTIALS_SUCCESS: null,
  TEST_CREDENTIALS_ERROR: null
};

types = actionize(types, (action) => `schooladmin/veracrossConfig/${action}`);

/**
 * Tests veracross API credentials.
 */
const testCredentials = () => apiAction(
  types.TEST_CREDENTIALS_BEGIN,
  types.TEST_CREDENTIALS_SUCCESS,
  types.TEST_CREDENTIALS_ERROR,
  (state) => apiFetch.post(
    state,
    duck.config.collectionApiPath() + '/test',
    {}
  )
);

export const entity = {
  ...duck,
  actions: {
    ...duck.actions,
    testCredentials
  }
}
